import React from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Button,
  useTheme,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import ClearIconML from '@/components/ClearIconML/index';
import { useIntl } from 'umi';
import { createOid } from '@/utils/eventtracing';

const SearchCondition = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef, MANUAL_OPERATION_TYPE } = props;
  const { memberCode, type, approvalState, mobile } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch } = useForm({
    defaultValues: {
      memberCode,
      type,
      approvalState,
      mobile,
    },
  });

  const resetData = () => {
    reset({
      memberCode: null,
      type: null,
      approvalState: null,
      mobile: null,
    });
    setValue('memberCode', null);
    setValue('type', null);
    setValue('approvalState', null);
    setValue('mobile', null);
    restClick && restClick();
  };

  //查询
  const handleSubmitSuccess = (values) => {
    handleSearch(values);
  };

  const watchMemberCode = watch('memberCode');
  console.log(watchMemberCode, 'watchMemberCode');

  const watchMemberPhone = watch('mobile');
  const watchType = watch('type');
  // const watchStatus = watch('approvalState');

  const handleClearType = () => {
    setValue('type', null);
  };

  // const handleClearStatus = () => {
  //   setValue('approvalState', null);
  // };

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="search-condition-wrap">
          <div className="card-content-wrap">
            <FormControl className="single-select">
              <Controller
                as={
                  <TextField
                    name="memberCode"
                    variant="standard"
                    // label="会员号"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl01',
                    })}
                    // type="number"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('memberCode', '');
                            }}
                            edge="end"
                          >
                            {watchMemberCode && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                }
                name="memberCode"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
            </FormControl>
            <FormControl className="single-select">
              <Controller
                as={
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    // label="手机号"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl03',
                    })}
                    // type="number"
                    // value={watchMemberCode}
                    defaultValue={''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                            }}
                            edge="end"
                          >
                            {watchMemberPhone && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                }
                name="mobile"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({
                  id: 'adjustment.members.n01.lbl03',
                })}
                defaultValue={''}
              />
            </FormControl>
            <FormControl variant="standard" className="single-select">
              <InputLabel>
                {/* 调整类型 */}
                {formatMessage({
                  id: 'adjustment.members.c01.lbl13',
                })}
              </InputLabel>
              <Controller
                as={
                  <Select className="select">
                    {MANUAL_OPERATION_TYPE &&
                      MANUAL_OPERATION_TYPE.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={item.dictCode}
                          name={item.nameZh}
                        >
                          {item.nameZh}
                        </MenuItem>
                      ))}
                  </Select>
                }
                defaultValue=""
                name="type"
                control={control}
              />
              <ClearIconML
                handleClick={handleClearType}
                clearValue={watchType}
              ></ClearIconML>
            </FormControl>
            {/* <FormControl variant="standard" className="single-select">
              <InputLabel>审核状态</InputLabel>
              <Controller
                as={
                  <Select className="select">
                    {MANUAL_OPERATION_APPROVE_STATE &&
                      MANUAL_OPERATION_APPROVE_STATE.map((item) => (
                        <MenuItem
                          key={item.id}
                          value={item.dictCode}
                          name={item.nameZh}
                        >
                          {item.nameZh}
                        </MenuItem>
                      ))}
                  </Select>
                }
                defaultValue=""
                label="Sub Channel"
                name="approvalState"
                control={control}
              />
              <ClearIconML
                handleClick={handleClearStatus}
                clearValue={watchStatus}
              ></ClearIconML>
            </FormControl> */}
          </div>
          {/* 按钮 */}
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 重置 */}
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>
            <Button
              data-log={JSON.stringify({
                oid: createOid('ev'),
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 查询 */}
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
